import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import {getRecommendedByName, showDate } from "./common";

const useStyles = makeStyles((theme) => ({
  typography: {
    fontWeight: 500,
    fontSize: 15,
  },
  detailsTypography: {
    marginRight: 20,
    fontWeight: 500,
  },
  button: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
    width: "40%",
    fontWeight: 600,
  },
  paper: {
    border: "1px solid",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    zIndex: "1600",
  },
}));

const DetailsAccordionRow = (props) => {
  const classes = useStyles();
  const { proposalReferee } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <TableRow key={proposalReferee.itemId}>
      <TableCell>{proposalReferee.name}</TableCell>
      <TableCell>
        <Button
          aria-describedby={id}
          type="button"
          size="small"
          disableElevation
          variant="contained"
          className={classes.button}
          onClick={handleClick}
        >
          Details
        </Button>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Box display="flex" padding={1}>
            <Typography
              className={classes.detailsTypography}
            >{`Date of Review Request: ${showDate(proposalReferee.evaluationSentDate)}`}</Typography>
            <Typography
              className={classes.detailsTypography}
            >{`Last Reminder Date: ${showDate(proposalReferee.reminderDate)}`}</Typography>
            <Typography
              className={classes.detailsTypography}
            >{`Reply Date: ${showDate(proposalReferee.agreementDay)}`}</Typography>
            <Typography
              className={classes.detailsTypography}
            >{`Review Received Date: ${showDate(proposalReferee.evaluationReceivedOn)}`}</Typography>
          </Box>
        </Popover>
      </TableCell>
      <TableCell>
        {getRecommendedByName(proposalReferee.recommendedBy)}
      </TableCell>
    </TableRow>
  );
};

export default function DetailsAccordionTable(props) {
  const classes = useStyles();
  const { proposalReferees, name } = props;
  const tableHeaders = [
    { label: "Referee", size: 300 },
    { label: "Details", size: 200 },
    { label: "Recommended By", size: 200 },
  ];
  return (
    <Accordion style={{margin:5}}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.typography}>{name}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Table>
          <TableHead>
            <TableRow>
              {tableHeaders.map((th) => (
                <TableCell key={th.label} style={{ width: th.size }}>
                  {th.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {proposalReferees.map((pr) => (
              <DetailsAccordionRow key={pr.itemID} proposalReferee={pr} />
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
}
